import { Availability } from './../models/availability.model';
import { handleError } from '../components/error-summary/error-handler.function';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { LocalStorageService } from 'app/shared/services/local-storage.service';
import { Observable } from 'rxjs/Observable';
import { GxUtilsService } from 'app/shared/services/gx-utils.service';
import { PassengersService } from 'app/shared/services/passenger.service';
import { TravelCentre } from 'app/shared/models/booking.model';
import { Passengers } from 'app/shared/models/passenger.model';
import { StopItem } from 'app/shared/services/reference-data.service';
import { SpecialAssistance } from 'app/shared/components/special-assistance/special-assistance.component';
import { AvailabilityOption, TravelLeg } from 'app/shared/models/timetables.model';
import { ApiError } from 'app/shared/services/action-updater.service';
import { PassengerFareType } from 'app/initial-data.service';
declare const Modernizr: any;

@Injectable()
export class TravelService {

    retrievingStops = false;

    constructor(private http: Http,
        private localStorageService: LocalStorageService,
        private gxUtilsService: GxUtilsService,
        private passengersService: PassengersService) {
    }

    getTravelCentres = () => {
        return this.http.get(`/umbraco/api/travel/GetTravelCentres`, null).map(r => r.json());
    }

    getTravelCentreDetails = (id: string) => {
        return this.http.get(`/umbraco/api/travel/GetTravelCentreDetails/${id}`, null).map(r => r.json());
    }

    updateInclusions = (options: UpdateInclusionsOptions) => {
        return this.http.post(`/umbraco/api/travel/UpdateInclusion`, options, null);
    }
    addTourToBooking = (options: AddTourToBookingOption) => {
        return this.http.put(`/umbraco/api/travel/AddTourToBooking`, options, null);
    }
    updateTourOnBooking = (options: UpdateTourOnBookingOption) => {
        return this.http.post('/umbraco/api/travel/UpdateTourOnBooking', options, null);
    }

    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      }


    getTimeStampedStorageObject(data) {
        return new TimeStampedStorageObject(new Date(), data);
    }
    
    storageItemHasExpired(data) {
        if (!data.timestamp) {
            return true;
        } else {
            var dataTimestamp = moment(data.timestamp);
            var timeStampExpiration = dataTimestamp.add(1,'d');
            var currentTimeStamp = moment();
            if (timeStampExpiration < currentTimeStamp) {
                return true;
            }
        }
        return false;
    }
     getStops = async () => {
        if (this.retrievingStops) {
            await this.sleep(1000);
        }
        const cachedStops = this.localStorageService.getTravelStops();

        if (cachedStops) {
            if(!cachedStops.timestamp){
                return cachedStops;
            }
            if(!this.storageItemHasExpired(cachedStops)){
                return cachedStops.data;
            }
        }

        this.retrievingStops = true;

        return this.http.get('/umbraco/api/travel/getstops', null).map((r) => {
            const stops: TimeStampedStorageObject = this.getTimeStampedStorageObject(r.json());
            this.storeStops(stops);
            this.retrievingStops = false;
            return stops.data;
            }
        );
    }

    loadStopsIntoStorage = () => {

        const cachedStops = this.localStorageService.getTravelStops();

        if (!cachedStops) {
            this.http.get('/umbraco/api/travel/getstops', null).map((r) => {
                const stops: TimeStampedStorageObject = this.getTimeStampedStorageObject(r.json());
                this.storeStops(stops);
                }).subscribe();
        }
    }

    getServiceLocations = (options: GetServiceLocationOption) => {
        return this.http.post('/umbraco/api/travel/GetServiceLocation', options, null);
    }

    getService = (options: GetServiceOption) => {
        return this.http.post('/umbraco/api/travel/GetService', options, null);
    }

    getSeating = (service, date: Date, origin, destination, bookingGuid, travelGuid) => {
        // tslint:disable-next-line:max-line-length
        return this.extractJson(this.http.get(`/umbraco/api/travel/GetServiceSeating?serviceReference=${service}&travelDate=${date}&origin=${origin}&destination=${destination}&bookingGuid=${bookingGuid}&travelGuid=${travelGuid}`));
    }

    updateSeating = (bookingGuid, sectorGuid, seating: Array<SeatAllocation>) => {
        const options: any = {};
        options.BookingGuid = bookingGuid;
        options.SectorGuid = sectorGuid;
        options.Seats = seating;
        return this.extractJson(this.http.post(`/umbraco/api/travel/UpdateServiceSeating`, options, null));
    }

    recalculateLocalStorageStopDistance = (stops, position) => {
        return this.addDistanceToStops(stops, position);
    }

    private addDistanceToStops = (stops, position) => {
        let userCoords = position;
        const defer = Observable.create();
        const setDistanceOnStop = (stop: any) => {
            if (stop.Longitude !== 0 && stop.Latitude !== 0) {
                stop.distance = this.gxUtilsService
                    .calculateDistance(userCoords.latitude,
                        userCoords.longitude,
                        stop.Latitude,
                        stop.Longitude);
            } else {
                stop.distance = 99999999999; // determine it as far away...
            }
        };

        if (!Modernizr.geolocation) {
            defer.resolve(stops);
        }

        const options = {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        },
            onLocationBeingFound = (pos) => {
                try {
                    userCoords = pos.coords;
                    _.each(stops, setDistanceOnStop);
                    defer.resolve(stops);
                } catch (err) {
                    defer.reject(`ERROR(${err.code}): ${err.message}`);
                }
            },
            onError = err => {
                defer.reject(`ERROR(${err.code}): ${err.message}`);
            };
        if (!userCoords) {
            navigator.geolocation.getCurrentPosition(onLocationBeingFound, onError, options);
        } else {
            _.each(stops, setDistanceOnStop);
            defer.resolve(stops);
        }
        return defer.promise;
    }

    private storeStops = (stops) => {
        const stopsObj = { data: stops };
        this.localStorageService.saveTravelStops(stops);
    }

    getAvailability = (availabilityOptions: AvailabilityOption) => {
        availabilityOptions.TravelLegs.forEach((travelLeg) => {
            travelLeg.destination = travelLeg.destination.toString();
            travelLeg.origin = travelLeg.origin.toString();
        });
        availabilityOptions.getAlternates = true;
        return this.extractJson(this.http.post('/umbraco/api/travel/postavailability', availabilityOptions, null));
    }
    getAvailabilityWithoutHandleErrors = (availabilityOptions: AvailabilityOption) => {
        return this.http.post('/umbraco/api/travel/postavailability', availabilityOptions, null);
    }

    getTimetable = (serviceDetails, serviceDate) => {
        return this.http.post('/umbraco/api/travel/posttimetable',
            {
                serviceDetails: serviceDetails,
                serviceDate: serviceDate
            },
            null);
    }

    getRouteTimetable = (travelGuid, routeNumber) => {
        return this.http.post('/umbraco/api/travel/postroutetimetable',
            {
                TravelGuid: travelGuid,
                RouteNumber: routeNumber
            },
            null);
    }

    getSectorAvailability = (options: GetSectorAvailabilityOptions): Observable<Availability[]> => {
        return this.extractJson(this.http.post('/umbraco/api/travel/GetSectorAvailabilityV2', options, null));
    }


    getAvailabilityViaTravelGuid = (travelGuid: string) => {
        const url = `/umbraco/api/travel/GetAvailabilityViaTravelGuid?travelGuid=${travelGuid}`;
        return this.http.get(url)
            .map(res => res.json());
    }
    getAvailabilityOptions(passengers: Passengers, from: StopItem, to: StopItem, isReturn: boolean,
        specialAssistance: SpecialAssistance, departureDate: string, returnDate: string, promoCode: string,
        fareTypes: PassengerFareType[]) {
        const fares = [],
            options = new AvailabilityOption();

        const passengerTypes = {
            'adult': { qty: passengers.adults },
            'concession': { qty: passengers.concessions },
            'accompaniedChild': { qty: passengers.accompaniedChildren },
            'infant': { qty: passengers.seatedInfant + passengers.nursedInfant + passengers.infants },
            // either 'seatedInfant' and 'nursedInfant' are 0 or 'infant' is 0
            'student': { qty: passengers.students }
        };
        // loop through each passenger type, if any passenger, retrieve its fare code.
        for (const key in passengerTypes) {
            if (passengerTypes.hasOwnProperty(key)) {
                const passengerType = key,
                    qty = passengerTypes[passengerType].qty;

                if (qty > 0) {
                    fares.push({
                        code: this.getFareBasisFor(passengerType, isReturn, fareTypes),
                        qty: qty
                    });
                }
            }
        }

        // INTEBUS ONLY ALLOWS A MAX OF 3 fare basis code so explode it if more
        if (fares.length > 3) {
            throw new ApiError('Too many fare types. Maximum allowed is 3.');
        }

        for (let i = 0; i < fares.length; i++) {
            options['fareBasis' + (i + 1) + 'Count'] = fares[i].qty;
            options['fareBasis' + (i + 1) + 'Code'] = fares[i].code;
        }
        // fareBasisCode 451 is for infants in general. The nursedInfant parameter indicates how many are NOT seated
        options.nursedInfants = passengers.nursedInfant;

        // deal with special assistance
        if (!!specialAssistance && specialAssistance.checked) {
            options.specialAssistance = true;
            options.sATypeId = specialAssistance.index;
        }

        options.isReturn = isReturn;
        options.TravelLegs.push(new TravelLeg(from.Code,
            to.Code,
            departureDate,
            promoCode));

        // RETURN TRIP
        if (isReturn) {
            options.TravelLegs.push(new TravelLeg(to.Code,
                from.Code,
                returnDate,
                promoCode));
        }
        return options;
    }
    getFareBasisFor(passengerType: string, isReturn: boolean, fareTypes: PassengerFareType[]) {
        // functions to be used to narrow down the list of fare types based on passenger type
        const filters = {
            'adult'(fareType: PassengerFareType) {
                return !fareType.IsChild &&
                    !fareType.IsInfant &&
                    !fareType.ConcessionCardRequired;
            },
            'student'(fareType: PassengerFareType) {
                return !fareType.IsChild &&
                    !fareType.IsInfant &&
                    fareType.ConcessionCardRequired &&
                    fareType.Description.toLowerCase().indexOf('student') > -1;
            },
            'concession'(fareType: PassengerFareType) {
                return !fareType.IsChild &&
                    !fareType.IsInfant &&
                    fareType.ConcessionCardRequired;
            },
            'accompaniedChild'(fareType: PassengerFareType) {
                return fareType.IsChild &&
                    !fareType.IsInfant &&
                    !fareType.ConcessionCardRequired &&
                    fareType.NonChildRequired;
            },
            'infant'(fareType: PassengerFareType) {
                return fareType.IsChild &&
                    fareType.IsInfant &&
                    !fareType.ConcessionCardRequired &&
                    fareType.NonChildRequired;
            },
        };
        if (!_.isFunction(filters[passengerType])) {
            throw new Error(`'${passengerType}' is not a valid passenger type`);
        }
        const list: any = _.filter(fareTypes, filters[passengerType]);
        return isReturn ? list[0].ReturnCode : list[0].Code;
    }

    getCategories = () => {
        return this.http.get('/umbraco/api/travel/GetCategories', null);
    }

    getPassTypesForCategory = (category) => {
        return this.http.get(`/umbraco/api/travel/GetPassTypesForCategory?category=${category}`, null);
    }

    getPass = (category, pass) => {
        return this.extractJson(this.http.get(`/umbraco/api/travel/GetPass2?category=${category}&pass=${pass}`));
    }

    private extractJson(o: Observable<any>) {
        return o.map(r => r.json()).catch(r => handleError(r));
    }
}

export class UpdateInclusionsOptions {
    constructor(private dateToBook: string, private bookingGuid: string, private tourGuid: string) { }
}

export class AddTourToBookingOption {
    constructor(
        private bookingGuid: string,
        private tourGuid: string,
        private dateToBook: string,
        private fareTypeCode: string,
        private fareTypeCurrency: string,
        private fareTypeCurrencyAmount: number,
        private sendConfirmation: boolean
    ) { }
}
export class UpdateTourOnBookingOption {
    constructor(
        private bookingGuid: string,
        private tourGuid: string,
        private dateToBook: string,
        private fareTypeCode: string,
        private fareTypeCurrency: string,
        private fareTypeCurrencyAmount: number,
        private sendConfirmation: boolean
    ) { }
}

export class GetServiceLocationOption {
    constructor(
        private ServiceCompany: string,
        private ServiceNumber: string,
        private DepDate: Date
    ) { }
}
export class GetServiceOption {
    constructor(
        private DestinationCode: string,
        private OriginCode: string,
        private RunningOnly: boolean,
        private Company: string,
        private Service: string,
        private TravelDate: Date
    ) { }
}

export class ServiceLocationDetails {
    constructor(
        public ActivityDateTime: Date,
        public Created: string,
        public Company: string,
        public DestinationName: string,
        public DestinationCode: string,
        public ScheduledArrivalDate: Date,
        public ScheduledDepartureDate: Date,
        public IgnitionStartOdometer: number,
        public IgnitionStartTime: Date,
        public Latitude: number,
        public Longitude: number,
        public Location: string,
        public NextStop: string,
        public Odometer: number,
        public OriginName: string,
        public OriginCode: string,
        public PreviousStopDepartureTime: Date,
        public PreviousStop: string,
        public Service: number,
        public VehicleID: string,
        public GPSUnitID: string,
        public IsRunning: boolean,
        public ScheduledStatus: string
    ) { }
}
class GetSectorAvailability {
    constructor(public sectorNumber: number, public travelDate?: string) { }
}
export class GetSectorAvailabilityOptions extends GetSectorAvailability {
    constructor(public bookingGuid: string, sectorNumber: number, public travelDate?: string) {
        super(sectorNumber, travelDate);
    }
}

export class TimeStampedStorageObject {
    constructor(public timestamp: Date, public data: any) { }
}
export enum SeatStatus{
    Available = 1,
    Unavailable = 2,
    Selected = 3
}
export class SeatAllocation {
        constructor(
            public Seat: string,
            public Row: number,
            public Status: SeatStatus
        ) {}
}


// WEBPACK FOOTER //
// ./src/app/shared/services/travel.service.ts